/**
 * Format a number of seconds as a stopwatch-style string.
 *   90    → "01:30"
 *   3725  → "1:02:05"
 * Zero and negative inputs are clamped to "00:00".
 */
export function formatStopwatch(seconds: number): string {
  const s = Math.max(0, Math.floor(seconds));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  return h > 0
    ? `${h}:${String(m).padStart(2, '0')}:${String(sec).padStart(2, '0')}`
    : `${String(m).padStart(2, '0')}:${String(sec).padStart(2, '0')}`;
}

/**
 * Compute the label + state for the count-down → overrun UI:
 *   - planned 25m, elapsed 5m   → { label: "20:00", overrun: false }
 *   - planned 25m, elapsed 26m  → { label: "+01:00", overrun: true }
 *   - planned null (no end time) → fall back to elapsed counted up.
 */
export function computeCountdown(elapsedSec: number, plannedSec: number | null | undefined) {
  if (plannedSec == null || plannedSec <= 0) {
    return { label: formatStopwatch(elapsedSec), overrun: false, fallback: true };
  }
  const remaining = plannedSec - elapsedSec;
  if (remaining >= 0) {
    return { label: formatStopwatch(remaining), overrun: false, fallback: false };
  }
  return { label: `+${formatStopwatch(-remaining)}`, overrun: true, fallback: false };
}
